import React from "react";
import './loading.css';

function Loading () {
    return(
        <section className='loading-component flex'>
            <span className='spinner'></span>
            <p className='loading-text'>Loading...</p>
        </section>
    );
};

export default Loading;